import { MetadataProductCard } from '@hyphengroup/cms-components/types/cmsTypes';
import { getProductCardsVertical } from '@hyphengroup/cms-components/utils/productVertical';
import { VerticalType } from '../types';

/**
 * Vertical a ProductMetaConfig block renders under; `undefined` means the page vertical.
 * Travel insurance is never taken from the cards: TI cards price from the page-level
 * travel quotes, which only a TravelPolicySearch page produces (CMS-1987).
 */
export const getProductBlockVertical = (
  cards: ReadonlyArray<MetadataProductCard> | undefined,
): VerticalType | undefined => {
  const vertical = getProductCardsVertical(cards);

  return vertical === 'TRAVEL_INSURANCE' ? undefined : vertical;
};
